import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { BtnClasses, Button } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { Component, Show } from 'solid-js';

export const ExtractionWorkflowSubtitle: Component = () => {
  const fxWorkspace = useFxWorkspaceContext();

  return (
    <Show when={fxWorkspace.selectedExtractionWorkflow()}>
      {(workflow) => (
        <div class="flex items-center justify-between gap-2">
          <p
            class="m-0 min-w-0 text-lg font-semibold"
            data-testid="extraction-workflow-panel-subtitle"
          >
            {t(
              `mobileMapping.fxWorkspace.extraction.workflow.${workflow()}.label`
            )}
          </p>
          <Button
            color={BtnClasses.TERTIARY}
            size="small"
            class="shrink-0"
            data-cy="change-extraction-workflow-button"
            onClick={() => fxWorkspace.requestChangeExtractionWorkflow()}
          >
            {t('mobileMapping.fxWorkspace.extraction.changeWorkflow')}
          </Button>
        </div>
      )}
    </Show>
  );
};
